import AppWithRoutes from "./AppWithRoutes";
import Masterlayout from "./Layout/Masterlayout";
import GlobalAppStoreProvider from "./packages/context/store/GlobalAppStoreProvider";
import UIStateProvider from "./packages/providers/UIStateProvider";

const App = () => {
  return (
    <UIStateProvider>
      <GlobalAppStoreProvider>
        <Masterlayout>
          <AppWithRoutes />
        </Masterlayout>
      </GlobalAppStoreProvider>
    </UIStateProvider>
  );
};
export default App;
